/**
 * Screens that aren't in the v1.0 build but have routes reserved so
 * the sidebar links don't 404. Each lands in a v1.1+ phase.
 */

// RulesPage moved to pages/rules/RulesPage — real Rules engine UI.
// TesterPage moved to pages/cpp-tester/TesterPage — real CPP A/B tester.

// AutopilotPage moved to pages/autopilot/AutopilotPage —
// real Activity log + "Autopilot · Coming soon" placeholder.

// SettingsPage stub removed — real Settings UI lives in pages/settings/*

export function NotFoundPage() {
  return (
    <div className="content" style={{ padding: "120px 28px", textAlign: "center" }}>
      <div className="serif" style={{ fontSize: 64 }}>404</div>
      <div className="muted" style={{ marginTop: 8 }}>That page doesn&apos;t exist.</div>
    </div>
  );
}
